module.exports = __webpack_public_path__ + "img/bf.74f63fef.svg";